;(function () {
  'use strict'

  angular.module('contrast.modal').factory('confirmModal', confirmModal)

  function confirmModal($q, dialogs) {
    'ngInject'

    // API
    var service = {
      open: open
    }

    return service

    /**
     * @description
     * - Opens a standard confirm modal
     * - Fixes the odd implementation of the dialogs service, where a cancel would usually be a reject, now it is a resolve
     * @param {{}} params
     * @param {string} params.title
     * @param {string} params.message
     * @param {{}} params.dialogOptions
     * @returns {promise} Resolves with boolean indicating confirmed/cancelled
     */
    function open(params) {
      return dialogs
        .confirm(params.title, params.message, params.dialogOptions)
        .result.then(function () {
          return true
        })
        .catch(function () {
          // Intentionally resolving this, because cancelling the dialog is
          // an intentional user decision and not an exception.
          return $q.resolve(false)
        })
    }
  }
})()
